'use client'

import { useEffect, useRef } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, $createParagraphNode, $createTextNode } from 'lexical'
import { $createMentionNode } from './MentionNode'
import { parseNotationString } from './SerializationPlugin'
import { generateObjectId } from './scriptUtils'

const OBJECT_ID_RE = /^[a-f0-9]{24}$/

export default function InitializationPlugin({ initialValue }) {
    const [editor] = useLexicalComposerContext()
    const initialized = useRef(false)

    useEffect(() => {
        if (initialized.current) return
        initialized.current = true
        if (!initialValue) return

        editor.update(() => {
            const root = $getRoot()
            root.clear()

            const lines = initialValue.split('\n')

            lines.forEach(line => {
                const paragraph = $createParagraphNode()
                const segments = parseNotationString(line)

                if (segments.length === 0) {
                    paragraph.append($createTextNode(''))
                } else {
                    segments.forEach(segment => {
                        if (segment.type === 'text') {
                            paragraph.append($createTextNode(segment.value))
                        } else if (segment.type === 'mention') {
                            const data = segment.value
                            const { id: rawId, type, characterId, checksum, ...rest } = data
                            const objectId = (typeof rawId === 'string' && OBJECT_ID_RE.test(rawId)) ? rawId : generateObjectId()

                            let mentionType, mentionId, mentionName
                            if (type === 'character') {
                                mentionType = 'character'
                                mentionId = characterId
                                mentionName = ''
                            } else {
                                mentionType = 'command'
                                mentionId = type
                                mentionName = type.charAt(0).toUpperCase() + type.slice(1)
                            }

                            paragraph.append(
                                $createMentionNode(mentionType, mentionId, mentionName, rest, objectId)
                            )
                        }
                    })
                }

                root.append(paragraph)
            })
        })
    }, [editor, initialValue])

    return null
}
